
        import { initializeApp } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-app.js';
        import { getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut } from 'https://www.gstatic.com/firebasejs/10.7.1/firebase-auth.js';
        
        const firebaseConfig = {
            apiKey: "AIzaSyBUrlmPw6Wbv7s2D5s4ncOl1mGJvJ99dCE",
            authDomain: "attar-v-moukdad-case-site.firebaseapp.com",
            projectId: "attar-v-moukdad-case-site",
            storageBucket: "attar-v-moukdad-case-site.firebasestorage.app",
            messagingSenderId: "366014092250",
            appId: "1:366014092250:web:d6968002d519c1fbf5e6e3"
        };
        
        const app = initializeApp(firebaseConfig);
        const auth = getAuth(app);
        
        // Show body now
        document.body.classList.remove('loading');
        
        // Auth state handler
        onAuthStateChanged(auth, (user) => {
            if (user) {
                document.getElementById('loginScreen').style.display = 'none';
                document.getElementById('app').style.display = 'block';
                initializeDashboard();
            } else {
                document.getElementById('loginScreen').style.display = 'flex';
                document.getElementById('app').style.display = 'none';
            }
        });
        
        // Login form
        document.getElementById('loginForm').addEventListener('submit', async (e) => {
            e.preventDefault();
            const email = document.getElementById('email').value;
            const password = document.getElementById('password').value;
            const btn = document.getElementById('loginBtn');
            const errorEl = document.getElementById('loginError');
            
            btn.disabled = true;
            btn.textContent = 'Signing in...';
            errorEl.style.display = 'none';
            
            try {
                await signInWithEmailAndPassword(auth, email, password);
            } catch (error) {
                errorEl.textContent = 'Invalid email or password';
                errorEl.style.display = 'block';
                btn.disabled = false;
                btn.textContent = 'Sign In';
            }
        });
        
        // Logout
        document.getElementById('logoutBtn').addEventListener('click', async () => {
            await signOut(auth);
        });
    